// alpine
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import collapse from '@alpinejs/collapse';

// import css
import '~/css/app.css'

// import icons
import '~/js/assets/icons.js'

// feature: swiper carousel
import '~/js/composables/swiper'

// feature: plyr video player
import '~/js/composables/plyr'

// feature: choices.js for custom selects
import '~/js/composables/choices'

// feature: scroll reveal animations
import { scrollRevealPlugin } from '~/js/composables/scroll-reveal'

// feature: formie form utilities
import '~/js/composables/formie'
window.Alpine = Alpine
Alpine.plugin(focus)
Alpine.plugin(collapse)
Alpine.plugin(scrollRevealPlugin)
Alpine.start()

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept()
}